/**
 * PulseTabs — sticky-ish tab bar under the hero. Client-side only for
 * now (no data change), but each tab is a Link so the URL reflects the
 * active surface, giving us clean deep-links later.
 */
import { useState } from "react";
import { Home, MapPin, Users, Clock, Heart } from "lucide-react";

const TABS = [
  { key: "for-you",   label: "For You",   icon: Home },
  { key: "near-you",  label: "Near You",  icon: MapPin },
  { key: "following", label: "Following", icon: Users },
  { key: "latest",    label: "Latest",    icon: Clock },
  { key: "causes",    label: "Causes",    icon: Heart },
];

export default function PulseTabs() {
  const [active, setActive] = useState("near-you");
  return (
    <div className="bg-gradient-to-b from-[#F5F9FE] to-white py-6" data-testid="sp-pulse-tabs">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <nav
          className="mx-auto flex flex-wrap items-center gap-1 bg-white rounded-full ring-1 ring-slate-200 shadow-sm p-1 w-fit"
          role="tablist"
        >
          {TABS.map((t) => {
            const Icon = t.icon;
            const isActive = t.key === active;
            return (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                data-testid={`sp-tab-${t.key}`}
                role="tab"
                aria-selected={isActive}
                className={`inline-flex items-center gap-2 h-10 px-4 sm:px-5 rounded-full text-sm font-semibold transition-colors ${
                  isActive
                    ? "bg-blue-600 text-white shadow-sm"
                    : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
                }`}
              >
                <Icon className="w-4 h-4" />
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
